import { create } from 'zustand'
import { getUserInfo } from '@/service'

type AppStore = {
  user: any
  title: string
  setTitle: (title: string) => void
  initData: () => Promise<any>
}

export const useAppStore = create<AppStore>((set) => ({
  user: null,
  title: '美洋金融传播',
  setTitle: (title: string) => {
    set(() => ({ title }))
  },
  initData: async () => {
    try {
      // 获取用户基本信息
      const user = await getUserInfo()

      return new Promise((resolve) => {
        set(() => ({
          user: user
        }))
        resolve({ user: user })
      })
    } catch (e: any) {
      console.error('e:', e)
      return new Promise((resolve) => {
        set(() => ({
          user: null
        }))
        resolve({ user: null })
      })
    }
  }
}))
